import React from 'react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';
import { Link } from 'inside-out/components/shared/link';
import { aqua, darkGrey } from 'inside-out/global-styles';

import { wrapperStyle, activeStyle } from './styles';

export class PageNav extends React.PureComponent {
	static propTypes = {
		activeUnderlineColor: PropTypes.string,
		textColor: PropTypes.string,
		activeTextColor: PropTypes.string,
		links: PropTypes.array,
		isActive: PropTypes.func,
		managed: PropTypes.shape({
			activeLink: PropTypes.string,
			onClick: PropTypes.func,
			filterId: PropTypes.number,
			filterManager: PropTypes.object,
		}),
	};

	static defaultProps = {
		textColor: darkGrey,
		activeUnderlineColor: aqua,
		activeTextColor: darkGrey,
	};

	constructor(props) {
		super(props);
		this.state = {
			...props,
			mobileActive: false,
		};
	}

	componentDidMount() {
		let filterId = Math.random() * 99999;
		this.setState({
			filterId: filterId,
		});
		if (this.state.managed && this.state.managed.filterManager) {
			this.state.managed.filterManager.subscribe({
				id: filterId,
				hide: () => {
					this.setState({ mobileActive: false });
				},
			});
		}
	}

	componentWillReceiveProps(newProps) {
		if (this.state.managed && this.state.managed.activeLink !== newProps.managed.activeLink) {
			this.setState({
				...this.state,
				managed: {
					...this.state.managed,
					activeLink: newProps.managed.activeLink,
				},
			});
		}
		if (this.props.links !== newProps.links) {
			this.setState({
				links: newProps.links
			});
		}
	}

	componentWillUnmount() {
		if (this.state.managed && this.state.managed.filterManager) {
			this.state.managed.filterManager.unsubscribe(this.state.filterId);
		}
	}

	render() {
		const { className } = this.props;
		const {
			links,
			activeUnderlineColor,
			textColor,
			activeTextColor,
			managed,
			mobileActive,
		} = this.state;
		const computedActiveStyle = activeStyle(activeUnderlineColor, activeTextColor);

		return (
			<React.Fragment>
				<nav className={cx(wrapperStyle(textColor, mobileActive), className)}>
					<a
						href="#page-nav-dropdown"
						onClick={e => {
							e.preventDefault();
							this.setState({
								mobileActive: !mobileActive,
							});
						}}
					/>
					<ul id="page-nav-dropdown">
						{links.map(link => (
							<li key={link.to}>
								{!managed && (
									<Link
										data-link={link.text}
										to={link.to}
										onClick={link.onClick || null}
										exact
										isActive={link.isActive}
										activeClassName={computedActiveStyle}
									>
										{link.text}
									</Link>
								)}
								{managed && (
									<a
										href={link.to}
										aria-current={link.managedKey === managed.activeLink}
										data-link={link.text}
										onClick={e => {
											this.setState({ mobileActive: false });
											managed.onClick(link.managedKey, e);
										}}
										className={link.managedKey === managed.activeLink ? computedActiveStyle : null}
									>
										{link.text}
									</a>
								)}
							</li>
						))}
					</ul>
				</nav>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/pageNav/component.js